import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { SectionPage } from '~/models/administration/sectionPage';
import { UserSummary } from '~/models/administration/user';
import { ApiServiceBase, API_NAMES } from '../api';

@Injectable({ providedIn: 'root' })
export class MeService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.administration);
  }

  getUser() {
    return this.http.get<UserSummary>(this._url('/me'));
  }

  getAllowedPages() {
    return this.http.get<SectionPage[]>(this._url('/allowed-pages'));
  }

  getPermissions() {
    return this.http.get<string[]>(this._url('/permissions'));
  }

  getAllPermissions() {
    return this.http.get<string[]>('Permissions');
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/users${v}`);
  }
}
